/**
 * 商城-地区-列表接口
 * @author： xuyd
 * @date：2024-10-01
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'

const serviceModule = context.sunflower

export default {

  /**
   * 检索列表
   */
  searchRegionList: (params) => {
    return request.post(serviceModule + "/api1/sys/region/searchRegionList", params);
  },

  /**
   * 保存
   */
  saveRegion: (params) => {
    return request.post(serviceModule + "/api1/sys/region/saveRegion", params);
  },

  /**
   * 删除
   */
  deleteRegion: (id) => {
    return request.post(serviceModule + "/api1/sys/region/deleteRegion", {id});
  },

}
